import * as React from 'react';
import cn from 'classnames';
import { marginClass, isArray, isDefined, getBorderColorClass, getBorderWidthClass, BorderLocation } from '../../../library';
export var Hr = function Hr(props) {
  var spacing = props.spacing;
  var classNames = cn(isDefined(spacing) ? marginClass(isArray(spacing) ? [spacing[0], null, spacing[1]] : [spacing, null]) : '', isDefined(props.color) ? getBorderColorClass(props.color) : '', isDefined(props.width) ? getBorderWidthClass(props.width, BorderLocation.BOTTOM) : '', props.className);
  return React.createElement("hr", {
    className: classNames
  });
};